export default class SelectRedirect {
  constructor(select) {
    this.select = select;
    this.bind();
  }

  bind() {
    this.onChange = this.onChange.bind(this);
    this.select.addEventListener('change', this.onChange);
  }

  onChange(e) {
    e.preventDefault();
    const index = this.select.selectedIndex;
    const options = this.select.options;
    const value = options[index].value;

    value && this.redirect(value);
  }

  redirect(url) {
    window.location = url;
  }
}
